module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ANGEL")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("T")]), _vm._v("here are angels all around us that we simply do not recognize and when being tenderly hugged by your spouse")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You are in the arms of an angel.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("When your children wrap their arms around your neck and head on your shoulder You are in the arms of an angel.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("When your pregnant daughter needs to cry on your shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You are in the arms of an angel.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And when your travails are over and when at the judgement bar your Lord and Savior says to you “Well done true and faithful servant” and holds both your hands")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You are in the arms of all the angels.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f0d8e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap009.vue
// module id = 93
// module chunks = 0